import gql from 'graphql-tag'
export default gql`
  query ProviderAuth {
    ProviderAuth @client {
      uid
      providerID
      userID
      displayName
      emailVerified
      token
      photoUrl
      email
      isAnonymous
      ready
    }
  }`
